import { databases, ID, client } from "@/lib/appwrite";
import { usePathname, useSearchParams } from "next/navigation";

export interface GenerateButtonProps {
    generatePasswords: () => void;
    buttonNameOverride?: string;
}

function GenerateButton({ generatePasswords: generateCallback, buttonNameOverride = "Generate" }: GenerateButtonProps) {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    const generateCallbackWrapper = async () => {
        await generateCallback();
        const callLogger = async () => {
            const result = await fetch("/api",
                {
                    method: "POST",
                    body: JSON.stringify({
                        method: "POST",
                        url: pathname,
                        body: "",
                        query: searchParams.toString(),
                        ip: ""
                    })
                }
            );
        }
        callLogger();
    }

    return (
        <div className='flex-grow flex justify-start'>
            <button className="btn btn-primary btn-md mt-4 w-1/2 lg:max-w-48 btn-outline" onClick={generateCallbackWrapper}>
                {buttonNameOverride}
            </button>
        </div>
    );
}

export default GenerateButton;